import Translate from "@casino/legacy/client/shared/i18n/Translate";
import isValidVolatility from "@casino/legacy/shared/utils/game/isValidVolatility";
import type { SingleGameFragment } from "@workspace/casino_core/fragments/SingleGameFragment";
import GameDetailsRow from "./shared/GameDetailsRow";

type Props = Pick<SingleGameFragment, "volatility">;

const VolatilityRow: FC<Props> = ({ volatility }) => {
  if (!isValidVolatility(volatility)) {
    return null;
  }
  return (
    <GameDetailsRow translateId="casino.volatility">
      <Translate id={`casino.volatility_${volatility}`} />
    </GameDetailsRow>
  );
};

export default VolatilityRow;
